import { render } from "./logistics.vue?vue&type=template&id=38d55480&scoped=true"
import script from "./logistics.vue?vue&type=script&lang=js"
export * from "./logistics.vue?vue&type=script&lang=js"

import "./logistics.vue?vue&type=style&index=0&id=38d55480&lang=scss&scoped=true"
import "./logistics.vue?vue&type=style&index=1&id=38d55480&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d55480"]])

export default __exports__